import React from "react";
import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import useAuth from "hooks/useAuth";

const DepositSummaryGuard = ({ children }) => {
  const { user, isLoggedIn } = useAuth();

  if (isLoggedIn && user && user.canViewDepositSummary === false) {
    return <Navigate to="/dashboard/default" replace />;
  }

  return children;
};

DepositSummaryGuard.propTypes = {
  children: PropTypes.node,
};

export default DepositSummaryGuard;
